export const ContentType = {
  None: 0,
  Layout: 1,
  Design: 2,
  DisplayRoom: 3,
  Loading: 4,
  QuotedItems: 5,
  RoomScene: 6,
};

export const ContentTypeName = {
  1: "Room Layout",
  2: "Design",
  3: "Room Ideas",
  6: "Room Scene",
};

export const ContentTypeNameTranslate = {
  1: "desktop.nav.roomLayout",
  2: "desktop.nav.designButton",
  3: "desktop.nav.roomIdeas",
  6: "desktop.nav.roomScene",
};

export const PartMenuType = {
  Simple: 0,
  Complex: 1,
};

export const UserPopupTypes = {
  Unlock: 1,    // simple User Login popup
  GetQuote: 2,  // Get quote button
  NewDesign: 3, // when N clicks happen & Email Design Click
  Schedule: 4,  // schedule button
};
export const ConfirmPopupTypes = {
  ConsultationRequest: 1,
  SqftResetChanges: 2,
  SqftUpdateQuestion: 3,
  AssignQuoteOnExistingUser: 4,
  DeleteCartItemsPopup: 5,
  ChangeWizardToPreviousStepSelection: 6,
  ReplaceRoomWhenItExistsInCartButWeAddNew: 7,
};

export const UserPopupContent = {
  register: "register",
  login: "login",
  terms: "terms",
  forgot: "forgot",
  twoFA: "twoFA",
  twoFAVerify: "twoFAVerify",
};

export const QuoteRequestType = {
  RequestQuote: 'RequestQuote',
  ScheduleAnAppointment: 'ScheduleAnAppointment',
  RequestDateTime: 'RequestDateTime',
  RegularDesign: 'RegularDesign',  //Email Design
  RequestConsultation: 'RequestConsultation'
};

export const UserAction = {
  Login: 1,
  Register: 2
};

export const SqftUpdateTypes = {
  Reset: 1,
  UpdateData: 2
};

export const dbFeatureRelatedFeaturesProperties = ["relatedFeatures", "bundledFeatures"];
export const dbFeatureFilterProperties = ["fabFilterValueIDs", "filterValueIDs"];
export const otherMissingProperties = ["thirdPartyAR3DUrls", "thirdPartyAR3DMetaData","lixilAR3DUrls","lixilQRCode"];
